import { Card } from 'ui-components/components/card';
import { PlanName } from './plan-name';
import { PlanCard } from './plan-card';
import style from '../migration-plan-modal.module.less';

export const CurrentPlanCard = ({ planDetails }) => {
  if (planDetails?.shouldHideCard) {
    return null;
  }

  return (
    <Card className={style['current-plan']}>
      <PlanName isCurrentPlan name={planDetails.name} />
      <PlanCard planDetails={planDetails} />
    </Card>
  );
};
